import { formatNumberWithSuffix } from "@/utils";
import { ApexOptions } from "apexcharts";

export const gridBarChart: ApexOptions = {
  chart: {
    type: "bar",
    width: "100%",
    height: "100%",
    offsetX: 0,
    offsetY: 0,
    parentHeightOffset: 0,
    redrawOnParentResize: true,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    line: {
      isSlopeChart: false,
    },
    bar: {
      horizontal: false,
      barHeight: "100%",
      columnWidth: "70%",
      borderRadius: 4,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
    },
  },
  title: {
    text: undefined,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [
      ["2018", "(Q1)"],
      ["2018", "(Q2)"],
      ["2018", "(Q3)"],
      ["2018", "(Q4)"],
      ["2019", "(Q1)"],
      ["2019", "(Q2)"],
      ["2019", "(Q3)"],
    ],
    type: "category",
    labels: {
      trim: true,
      style: {
        fontSize: "14px",
        colors: "#8E9494",
        fontFamily: "Inter",
        cssClass: "x-labels",
      },
    },
    axisTicks: {
      show: false, // hide bottom border ticks
    },
  },
  yaxis: {
    tickAmount: 4,
    title: {
      text: undefined,
    },
    labels: {
      formatter: function (val: number) {
        if (!val) return val.toString();
        return formatNumberWithSuffix(val);
      },
      style: {
        fontSize: "14px",
        colors: "#8C9198",
        fontFamily: "Inter",
      },
    },
    axisTicks: {
      show: true, // show left border ticks
    },
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return `$${formatNumberWithSuffix(val)}`;
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
  grid: {
    borderColor: "#D8DAE5",
    strokeDashArray: 0,
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: ["#0B494B"],
};

export const barChartConfig: ApexCharts.ApexOptions = {
  chart: {
    // type: "bar",
    type: "area",
    height: "100%",
    toolbar: {
      show: false,
    },
    parentHeightOffset: 0,
  },
  // colors: ["#0B494B"],
  colors: ["#052223"],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "65%",
      borderRadius: 4,
      borderRadiusApplication: "around",
      borderRadiusWhenStacked: "all",
      barHeight: "100%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    // show: false,
    curve: 'smooth'
  },
  xaxis: {
    categories: [2020, 2021, 2022, 2023],
    labels: {
      style: {
        fontFamily: "Inter",
        fontSize: "12px",
        colors: "#AEB3B3",
      },
    },
    offsetY: 0,
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    tickAmount: 5,
    labels: {
      formatter: function (val: number) {
        return formatNumberWithSuffix(val);
      },
      offsetX: -10,
      style: {
        fontSize: "10px",
        colors: "#AEB3B3",
        fontFamily: "Inter",
        fontWeight: 500,
      },
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    y: {
      formatter: function (val: number) {
        return formatNumberWithSuffix(val);
      },
    },
  },
};

export const stackBarChartConfig: ApexOptions = {
  noData: {
    text: "No data",
  },
  chart: {
    id: "single-bar-horizontal-stack",
    type: "bar",
    animations: {
      enabled: true,
      easing: "easein",
      speed: 500,
      dynamicAnimation: {
        enabled: true,
        speed: 300,
      },
    },
    offsetX: 0,
    offsetY: 0,
    sparkline: { enabled: true },
    stacked: true,
    stackOnlyBar: true,
    stackType: "100%",
    height: "100%",
    width: "100%",
    parentHeightOffset: 0,
    redrawOnParentResize: true,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    line: {
      isSlopeChart: false,
    },
    bar: {
      horizontal: true,
      barHeight: "100%",
      columnWidth: "100%",
      borderRadius: 4,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
    },
  },
  title: {
    text: undefined,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ["2024"],
    labels: {
      show: false, // bottom labels
    },
    axisBorder: {
      show: false, // left border
    },
    axisTicks: {
      show: false, // bottom border ticks
    },
  },
  yaxis: {
    title: {
      text: undefined,
    },
    labels: {
      show: false, // Hide category labels
    },
    axisBorder: {
      show: false, // Hide the left border of the y-axis
    },
    axisTicks: {
      show: false, // Hide the ticks on the y-axis
    },
    show: false,
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return `$${formatNumberWithSuffix(val)}`;
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
  grid: {
    show: false,
  },
};

export const multiStackBarChart: ApexOptions = {
  noData: {
    text: "No Data Available!",
  },
  colors: ["#1CB4BA", "#0B494B"],
  chart: {
    type: "bar",
    width: "100%",
    height: "100%",
    stacked: true,
    parentHeightOffset: 0,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      borderRadius: 2,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
      rangeBarGroupRows: true,
      barHeight: "50%",
      dataLabels: {
        total: {
          enabled: true,
          offsetX: 12,
          offsetY: 0,
          formatter: function (val) {
            return formatNumberWithSuffix(Number(val));
          },
          style: {
            fontSize: "14px",
            fontWeight: 500,
            color: "#116B6F",
            fontFamily: "Inter",
          },
        },
      },
    },
  },
  legend: { show: false },
  stroke: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    floating: true,
    labels: {
      formatter: function (val: string) {
        return formatNumberWithSuffix(Number(val));
      },
      style: {
        colors: ["#8E9494"],
        fontFamily: "Inter",
      },
      offsetX: -5,
      offsetY: -5,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    floating: true,
    labels: {
      formatter: function (_, opt) {
        const label = opt?.w?.globals?.labels?.[opt?.dataPointIndex];
        const acheivedDuty = formatNumberWithSuffix(
          Number(opt?.w?.globals?.series?.[0]?.[opt.dataPointIndex])
        );
        const percentage = (
          (opt?.w?.globals?.series?.[0]?.[opt?.dataPointIndex] /
            (opt?.w?.globals?.series?.[0]?.[opt?.dataPointIndex] +
              opt?.w?.globals?.series?.[1]?.[opt?.dataPointIndex])) *
          100
        ).toFixed(2);

        if (
          acheivedDuty &&
          !isNaN(acheivedDuty as any) &&
          percentage &&
          !isNaN(percentage as any)
        ) {
          return `${label}  |  ${acheivedDuty} (${percentage}%)`;
        }

        return label;
      },
      align: "left",
      offsetY: -22,
      style: {
        colors: ["#2E2C34"],
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: "Plus Jakarta Sans",
      },
      maxWidth: 300,
    },
    title: {
      text: undefined,
    },
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return formatNumberWithSuffix(val);
      },
    },
  },
  fill: {
    opacity: 1,
  },
  grid: {
    borderColor: "#D8DAE5",
    strokeDashArray: 8,
    xaxis: {
      lines: {
        offsetX: 10,
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      left: 0,
      top: 0,
      bottom: 10,
    },
  },
};
